import React from "react";
import Skeleton from "@mui/material/Skeleton";

const ProfileCardsSkeleton = ({ card }) => {
      const skeletons = Array.from({ length: card });
  return (
    <div className="max-w-8xl mx-auto p-8 bg-[#fff5f5] rounded-3xl shadow-lg animate-pulse">
      {/* Header Skeleton */}
      <div className="flex flex-col items-center text-center space-y-4 mb-12">
        <div className="flex items-center justify-center space-x-3">
          <Skeleton
            variant="circular"
            width={32}
            height={32}
            sx={{ bgcolor: "rgba(255,99,99,0.2)" }}
          />
          <Skeleton
            variant="text"
            width={160}
            height={40}
            sx={{
              bgcolor: "rgba(255,99,99,0.25)",
              borderRadius: "10px",
            }}
          />
        </div>

        <Skeleton
          variant="text"
          width="70%"
          height={50}
          sx={{
            bgcolor: "rgba(255,182,193,0.3)",
            borderRadius: "12px",
          }}
        />
        <Skeleton
          variant="text"
          width="85%"
          height={30}
          sx={{
            bgcolor: "rgba(255,182,193,0.25)",
            borderRadius: "10px",
          }}
        />
      </div>

      {/* Profile Cards Grid Skeleton */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {skeletons.map((_, i) => (
          <div
            key={i}
            className="flex flex-col bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300"
          >
            {/* Image Skeleton */}
            <div className="relative">
              <Skeleton
                variant="rounded"
                width="100%"
                height={220}
                sx={{
                  bgcolor: "rgba(255,99,99,0.15)",
                  borderRadius: "16px",
                }}
              />
              <div className="absolute top-3 right-3">
                <Skeleton
                  variant="circular"
                  width={30}
                  height={30}
                  sx={{ bgcolor: "rgba(255,99,99,0.2)" }}
                />
              </div>
              <div className="absolute top-3 left-3">
                <Skeleton
                  variant="rounded"
                  width={70}
                  height={25}
                  sx={{
                    bgcolor: "rgba(255,0,0,0.25)",
                    borderRadius: "20px",
                  }}
                />
              </div>
            </div>

            {/* Content Skeleton */}
            <div className="mt-5 space-y-3">
              <Skeleton
                variant="text"
                width="80%"
                height={30}
                sx={{ bgcolor: "rgba(255,182,193,0.35)" }}
              />
              <Skeleton
                variant="text"
                width="60%"
                height={25}
                sx={{ bgcolor: "rgba(255,182,193,0.25)" }}
              />

              {/* Tags */}
              <div className="flex space-x-3 mt-3">
                <Skeleton
                  variant="rounded"
                  width={90}
                  height={35}
                  sx={{
                    bgcolor: "rgba(255,99,99,0.2)",
                    borderRadius: "20px",
                  }}
                />
                <Skeleton
                  variant="rounded"
                  width={90}
                  height={35}
                  sx={{
                    bgcolor: "rgba(255,99,99,0.2)",
                    borderRadius: "20px",
                  }}
                />
              </div>

              {/* Button Skeleton */}
              <div className="mt-6">
                <Skeleton
                  variant="rounded"
                  width="100%"
                  height={45}
                  sx={{
                    bgcolor: "rgba(255,99,99,0.25)",
                    borderRadius: "12px",
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileCardsSkeleton;
